import { isNull } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';
import { Options } from 'react-select';

import { useAppSelector } from '../../../../hooks/react-redux';
import { Dropdown, DropdownOption } from '../../../shared/dropdown/Dropdown';
import { Text } from '../../../shared/text/Text';
import { getAllUsers } from '../../users/store';
import styles from '../Workflow.module.scss';

interface EmailHeaderElementsProps {
    userIds: number[] | null;
    subject: string;
    updateUserIds: (value: number[] | null) => void;
    updateSubject: (value: string) => void;
    isEditing: boolean;
    testId: string;
}

export const EmailHeaderElements: React.FC<EmailHeaderElementsProps> = ({ userIds, subject, updateSubject, updateUserIds, isEditing, testId }) => {
    const allUsers = useAppSelector(getAllUsers);
    const usernameOptions = useMemo(() => allUsers.map(({ userId, username }) => ({ value: userId.toString(), label: username })), [allUsers]);
    const selectedUsers = useMemo(() => !isNull(userIds) && userIds.length > 0 && usernameOptions.filter(({ value }) => userIds.includes(parseInt(value))) || null, [userIds, usernameOptions]);

    const setEmailUserIds = useCallback((value: DropdownOption | Options<DropdownOption> | null) => {
        let userIds = null;
        if (!isNull(value)) {
            userIds = (value as Options<DropdownOption>).map(({ value }) => parseInt(value));
        }
        updateUserIds(userIds);
    }, [updateUserIds]);

    return (
        <div className={styles.emailHeaderWrapper} data-testid={`${testId}-header-wrapper`}>
            <div className={styles.emailUsersWrapper} data-testid={`${testId}-users-wrapper`}>
                <div className={styles.emailContentLabel} data-testid={`${testId}-users-label`}>To: </div>
                <div className={styles.emailUsersDropdown}>
                    <Dropdown
                        value={selectedUsers}
                        options={usernameOptions}
                        onChange={val => setEmailUserIds(val)}
                        menuPortalTarget={document.body}
                        testId={`${testId}-send-email-users`}
                        isMulti={true}
                        isClearable={true}
                        maxControlHeight='fit-content'
                        disabled={!isEditing}
                    />
                </div>
            </div>
            <div className={styles.emailSubjectWrapper} data-testid={`${testId}-subject-wrapper`}>
                <div className={styles.emailContentLabel} data-testid={`${testId}-subject-label`}>Subject: </div>
                <div className={styles.emailSubjectInput}>
                    <Text
                        marginBottom='0'
                        testId={`${testId}-subject`}
                        maxLength={128}
                        value={subject}
                        onChange={e => updateSubject(e.target.value)}
                        placeholder='Subject...'
                        disabled={!isEditing}
                    />
                </div>
            </div>
        </div>
    );
};

